export default __webpack_public_path__ + "static/media/board.29cad0bb.svg";